























import { Nullable } from '@/types';
import Vue from 'vue';
import normalizeSerialNumber from '@/helpers/serial-number';

export default Vue.extend({
  props: {
    value: {
      type: String,
      default: '',
    },
    numeric: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      input: '',
      scrollToTimeout: null as Nullable<number>,
    };
  },

  watch: {
    value: {
      immediate: true,
      handler(val: string) {
        this.input = val;
      },
    },
  },

  methods: {
    save() {
      this.input = normalizeSerialNumber(this.input);
      this.$emit('input', this.input);
      this.$emit('save', this.input);
    },

    scrollTo(evt?: KeyboardEvent) {
      if (this.scrollToTimeout) window.clearTimeout(this.scrollToTimeout);

      if (!evt || evt.key !== 'Enter') {
        this.scrollToTimeout = window.setTimeout(
          () => this.$scrollTo((this.$refs.input as Vue).$el, 100, { offset: -150 }),
          250,
        );
      }
    },
  },
});
